import React from "react";
import { getTrackByMediaTypeAndParticipant } from "../../../base/tracks";
import Avatar from "../../../base/avatar/components/Avatar";
import Video from "../../../base/media/components/Video";
import { MEDIA_TYPE } from "../../../base/media";
import { connect } from "../../../base/redux";
import { getDominantSpeakerParticipant } from "../../../base/participants";

export const audioVideoStatus = (type, id, isGallery = "", _tracks) => {
    let val;
    if (type === "video") {
        val = getTrackByMediaTypeAndParticipant(_tracks, MEDIA_TYPE.VIDEO, id);
    } else {
        val = getTrackByMediaTypeAndParticipant(_tracks, MEDIA_TYPE.AUDIO, id);
    }

    if (isGallery === "Y") {
        return val !== undefined ? val : true;
    }
    return val !== undefined ? val.muted : true;
};

function HorizontalTiledView(props) {
    const {
        _participants,
        _tracks,
        _tileViewEnabled,
        screenSharedUserID,
        fireGroupParticipants,
        additional_moderator,
    } = props;
    const isDominant = getDominantSpeakerParticipant(APP.store.getState());

    return (
        <div className="horizontal_div_1">
            {(_tileViewEnabled || !_tileViewEnabled) && (
                <div className="horizontal_div_2">
                    {_participants.length > 0 &&
                        _participants
                            .filter((v) => v.id !== undefined)
                            .map((val, index) => {
                                let trackVideoStatus = audioVideoStatus(
                                    "video",
                                    val.id,
                                    "Y",
                                    _tracks
                                );
                                let access = fireGroupParticipants?.[val.id]
                                    ?.owner
                                    ? "Host"
                                    : "";
                                let videoTrack =
                                    getTrackByMediaTypeAndParticipant(
                                        _tracks,
                                        MEDIA_TYPE.VIDEO,
                                        val.id
                                    );
                                let additionalModerator =
                                    additional_moderator &&
                                    additional_moderator.includes(val.id)
                                        ? true
                                        : false;
                                if (screenSharedUserID) {
                                    if (val.id === screenSharedUserID) {
                                        let name =
                                            val.name && val.name.split(" ");
                                        return (
                                            <div className="tile-big-screen screenshare-boxshadow">
                                                <Video
                                                    className={`video-input-preview-display flipVideoY largeVideoTags ${
                                                        videoTrack?.videoType ===
                                                        "desktop"
                                                            ? "object-fit-contain"
                                                            : "video-view-transform"
                                                    }`}
                                                    videoTrack={{
                                                        jitsiTrack:
                                                            trackVideoStatus.jitsiTrack,
                                                    }}
                                                />
                                                <div className="screen-share-name-div">
                                                    <span>{`Viewing ${name[0]}'s screen`}</span>
                                                </div>
                                            </div>
                                        );
                                    }
                                } else if (
                                    val.dominantSpeaker ||
                                    (index === 0 && !isDominant)
                                ) {
                                    return (
                                        <div
                                            className={`tile-big-screen ${
                                                val.dominantSpeaker
                                                    ? "isdominant-border"
                                                    : ""
                                            }${
                                                _participants?.length === 1
                                                    ? " horizontal-height"
                                                    : ""
                                            }`}
                                        >
                                            {(access === "Host" ||
                                                additionalModerator) && (
                                                <span className="participant-active-crown">
                                                    <img
                                                        src="public/assets/images/crown-img.svg"
                                                        alt="crown"
                                                    />
                                                </span>
                                            )}
                                            {trackVideoStatus.muted ||
                                            trackVideoStatus.muted ===
                                                undefined ? (
                                                <Avatar
                                                    className={`avatar-container largeVideoTags`}
                                                    participantId={val.id}
                                                    size={100}
                                                    displayName={val.name}
                                                    url={val.avatarURL}
                                                />
                                            ) : (
                                                <Video
                                                    className={`video-input-preview-display flipVideoY largeVideoTags ${
                                                        videoTrack?.videoType ===
                                                        "desktop"
                                                            ? "object-fit-contain"
                                                            : "video-view-transform"
                                                    }`}
                                                    videoTrack={{
                                                        jitsiTrack:
                                                            trackVideoStatus.jitsiTrack,
                                                    }}
                                                />
                                            )}
                                            <h6 className="meeting-user-name">
                                                {`${val.name} ${
                                                    access === "Host" ||
                                                    additionalModerator
                                                        ? "(Host)"
                                                        : ""
                                                }`}
                                            </h6>
                                        </div>
                                    );
                                }
                            })}
                    <div
                        className={`horizontal-tile-div ${
                            _participants?.length === 1 ? "d-none" : ""
                        }`}
                    >
                        <div class="owl-carousel owl-theme">
                            {_participants.length > 0 &&
                                _participants
                                    .filter((v) => v.id !== undefined)
                                    .map((val, index) => {
                                        let trackVideoStatus = audioVideoStatus(
                                            "video",
                                            val.id,
                                            "Y",
                                            _tracks
                                        );
                                        let access = fireGroupParticipants?.[
                                            val.id
                                        ]?.owner
                                            ? "Host"
                                            : "";
                                        let videoTrack =
                                            getTrackByMediaTypeAndParticipant(
                                                _tracks,
                                                MEDIA_TYPE.VIDEO,
                                                val.id
                                            );
                                        let additionalModerator =
                                            additional_moderator &&
                                            additional_moderator.includes(
                                                val.id
                                            )
                                                ? true
                                                : false;
                                        if (screenSharedUserID) {
                                            if (
                                                val.id !== screenSharedUserID &&
                                                _participants.length > 1
                                            ) {
                                                return __getParticipantsList(
                                                    _participants,
                                                    access,
                                                    trackVideoStatus,
                                                    val,
                                                    videoTrack,
                                                    additionalModerator
                                                );
                                            }
                                        }
                                        if (
                                            !isDominant &&
                                            !screenSharedUserID
                                        ) {
                                            if (index === 0) return false;
                                            return __getParticipantsList(
                                                _participants,
                                                access,
                                                trackVideoStatus,
                                                val,
                                                videoTrack,
                                                additionalModerator
                                            );
                                        } else if (
                                            isDominant &&
                                            !screenSharedUserID &&
                                            !val.dominantSpeaker &&
                                            _participants.length > 1
                                        ) {
                                            return __getParticipantsList(
                                                _participants,
                                                access,
                                                trackVideoStatus,
                                                val,
                                                videoTrack,
                                                additionalModerator
                                            );
                                        }
                                    })}
                        </div>
                    </div>
                </div>
            )}
            {props.children}
        </div>
    );
}

const __getParticipantsList = (
    _participants,
    access,
    trackVideoStatus,
    val,
    videoTrack,
    additionalModerator
) => {
    return (
        <div className="item">
            <div
                className={`horizontal-tile-box ${
                    _participants.length === 1
                        ? "horizontal-tile-full-screen"
                        : ""
                } ${val.dominantSpeaker ? "isdominant-border" : ""}`}
            >
                {(access === "Host" || additionalModerator) && (
                    <span className="participant-active-crown">
                        <img
                            src="public/assets/images/crown-img.svg"
                            alt="crown"
                        />
                    </span>
                )}
                {trackVideoStatus.muted ||
                trackVideoStatus.muted === undefined ? (
                    <Avatar
                        className={`avatar-container largeVideoTags`}
                        participantId={val.id}
                        size={200}
                        displayName={val.name}
                        url={val.avatarURL}
                    />
                ) : (
                    <Video
                        className={`video-input-preview-display flipVideoY largeVideoTags ${
                            videoTrack?.videoType === "desktop"
                                ? "object-fit-contain"
                                : "video-view-transform"
                        }`}
                        videoTrack={{ jitsiTrack: trackVideoStatus.jitsiTrack }}
                    />
                )}
                <h6 className="meeting-user-name">
                    {`${val.name} ${
                        access === "Host" || additionalModerator ? "(Host)" : ""
                    }`}
                </h6>
            </div>
        </div>
    );
};

const _mapStateToProps = (state) => {
    return {
        _tileViewDimensions: state["features/filmstrip"].tileViewDimensions,
        additional_moderator: state["features/nxatel"].additional_moderator,
    };
};

export default connect(_mapStateToProps)(HorizontalTiledView);
